module.exports = "https://static.wagwalking.com/_next/static/images/drop-in-2-c92f652afa3baa3ad4f41ec73c3b2a71.svg";